<template>
  <div>
    <b-card no-body>
      <b-row class="mb-3">
        <!-- tested -->
        <b-col class="mb-2" md="12" lg="4" xl="4">
          <b-row class="mb-3">
            <b-col class="mb-2" md="12" lg="12" xl="12"> 
              <span class="text-white h3">Tested By</span>
            </b-col>
            <hr class="hr" />
            <b-col class="mb-2" md="12" lg="12" xl="12">
              <label class="mb-1 text-white" for="">Name</label>
              <input type="text" disabled placeholder="auto populated after acceptance" class="form-control" v-model="oModel.tested.tested_by_name">
            </b-col>
            <b-col class="mb-2" md="12" lg="12" xl="12">
              <label class="mb-1 text-white" for="">Company</label>
              <input type="text" disabled placeholder="auto populated after acceptance" class="form-control" v-model="oModel.tested.tested_by_company">
            </b-col>
            <b-col class="mb-2" md="12" lg="12" xl="12">
              <label class="mb-1 text-white" for="">Date</label>
              <input type="text" disabled placeholder="auto populated after acceptance" class="form-control" v-model="oModel.tested.tested_date">
            </b-col>
            <b-col class="mb-2" md="12" lg="12" xl="12" v-show="oModel.status == 'REJECTED'">
              <label class="mb-1 text-white" for="">Rejected Comment</label>
              <textarea disabled class="form-control" rows="3" v-model="oModel.rejected.rejected_remarks"></textarea>
            </b-col>
          </b-row>
          <!-- submit button -->
          <b-row class="mb-3" v-show="approval_tested">
            <b-col class="mb-2">
              <div style="float: right;">
                <base-button size="sm" type="primary" @click="save_acceptance('tested')">Tested Acceptance</base-button>
              </div>
            </b-col>
          </b-row>
          <hr class="hr" v-show="approval_tested"/>
        </b-col>
        <!-- verified -->
        <b-col class="mb-2" md="12" lg="4" xl="4">
          <b-row class="mb-3">
            <b-col class="mb-2" md="12" lg="12" xl="12"> 
              <span class="text-white h3">Verified By</span>
            </b-col>
            <hr class="hr" />
            <b-col class="mb-2" md="12" lg="12" xl="12">
              <label class="mb-1 text-white" for="">Name</label>
              <input type="text" disabled placeholder="auto populated after acceptance" class="form-control" v-model="oModel.verified.verified_by_name">
            </b-col>
            <b-col class="mb-2" md="12" lg="12" xl="12">
              <label class="mb-1 text-white" for="">Company</label>
              <input type="text" disabled placeholder="auto populated after acceptance" class="form-control" v-model="oModel.verified.verified_by_company">
            </b-col>
            <b-col class="mb-2" md="12" lg="12" xl="12">
              <label class="mb-1 text-white" for="">Date</label>
              <input type="text" disabled placeholder="auto populated after acceptance" class="form-control" v-model="oModel.verified.verified_date">
            </b-col>
          </b-row>
          <!-- submit button -->
          <b-row class="mb-3" v-show="approval_verified">
            <b-col class="mb-2">
              <div style="float: right;">
                <base-button size="sm" type="danger" @click="action_reject('show_modal')">Reject</base-button>
                <base-button size="sm" type="primary" @click="save_acceptance('verified')">Verified Acceptance</base-button>
              </div>
            </b-col>
          </b-row>     
          <hr class="hr" v-show="approval_verified"/>
        </b-col>
        <!-- accepted -->
        <b-col class="mb-2" md="12" lg="4" xl="4">
          <b-row class="mb-3">
            <b-col class="mb-2" md="12" lg="12" xl="12"> 
              <span class="text-white h3">Accepted By</span>
            </b-col>
            <hr class="hr" />
            <b-col class="mb-2" md="12" lg="12" xl="12">
              <label class="mb-1 text-white" for="">Name</label>
              <input type="text" disabled placeholder="auto populated after acceptance" class="form-control" v-model="oModel.accepted.accepted_by_name">
            </b-col>
            <b-col class="mb-2" md="12" lg="12" xl="12">
              <label class="mb-1 text-white" for="">Company</label>
              <input type="text" disabled placeholder="auto populated after acceptance" class="form-control" v-model="oModel.accepted.accepted_by_company">
            </b-col>
            <b-col class="mb-2" md="12" lg="12" xl="12">
              <label class="mb-1 text-white" for="">Date</label>
              <input type="text" disabled placeholder="auto populated after acceptance" class="form-control" v-model="oModel.accepted.accepted_date">
            </b-col>
          </b-row>
          <!-- submit button -->
          <b-row class="mb-3" v-show="approval_accepted">
            <b-col class="mb-2">
              <div style="float: right;">
                <base-button size="sm" type="danger" @click="action_reject('show_modal')">Reject</base-button>
                <base-button size="sm" type="primary" @click="save_acceptance('accepted')">Sembcorp Acceptance</base-button>
              </div>
            </b-col>
          </b-row>
          <hr class="hr" v-show="approval_accepted"/>    
        </b-col>
      </b-row>

    </b-card>



    <!-- Modal loading / in progress -->
    <!-- <b-modal ref="modal-loading-in-progress" size="lg" centered hide-footer hide-header title="" :no-close-on-backdrop="true"> -->
    <b-modal ref="modal-loading-in-progress" size="lg" centered hide-footer hide-header title="">
      <div class="d-block">
        <!-- date | time | project name | site name -->
        <b-row class="mb-3">
          <b-col>
            <div class="text-center text-muted mb-4">
              <h1 class="text-white"><b>Loading in progress</b></h1>
            </div>
            <div class="text-center">
              <div style="color: #ffffff;">
                <!-- <span class="fa fa-spinner fa-spin fa-3x"></span> -->
                <span class="icon-spinner-cs"></span>
              </div>
            </div>
          </b-col>
        </b-row>
      </div>
    </b-modal>

    <!-- modal reject -->
    <b-modal ref="modal-reject-acceptance" size="lg" centered hide-footer hide-header title="">
      <div class="d-block">
        <!-- comment -->
        <b-row class="mb-3">
          <b-col class="mb-2" md="12" lg="12" xl="12">
            <label class="mb-1 text-white" for="">Comment</label>
            <textarea class="form-control" rows="3" placeholder="" v-model="oModel.rejected.rejected_remarks"></textarea>
          </b-col>
        </b-row>
        <!-- submit button -->
        <b-row class="mb-3">
          <b-col class="mb-2">
            <div style="float: right;">
              <base-button @click="action_reject('hide_modal')" type="danger" size="sm" outline>Cancel</base-button>
              <base-button type="btn btn-sm base-button btn-danger" @click="action_reject('execute')">Submit Reject</base-button>
            </div>
          </b-col>
        </b-row>          
      </div>
    </b-modal>

  </div>
</template>


<script>
import { LoginURL, clientId, clientSecret, apiDomain, getHeader, getcurrentDate } from "@/assets/js/config.js";
import ErrorFunctionMixin from "@/assets/js/errorFunctionMix.js";
import CustomLibHelper from "@/assets/js/customLibHelper.js";
import axios from "axios";

// import { ToggleButton } from 'vue-js-toggle-button'

export default {
  props: ['shareData', 'acceptanceData'],
  mixins: [ErrorFunctionMixin, CustomLibHelper],
  components: {
    // ToggleButton,
  },
  data() {
    return {
      oDev: {
        debug: false,
      },
      // oField: {
      //   toggle_yesno_color: { checked: '#75C791', unchecked: '#787785', disabled: '#CCCCCC' },
      //   toggle_yesno_value: { checked: 'Yes', unchecked: 'No' },
      // },
      oUser: {
        id: null,
        name: null,
        role_id: null,
        role_name: null,
        contractor_id: null,
        contractor_code: null,
        contractor_name: null,
      },
      oModel: {
        status: null,
        tested: {
          "tested_by_name": null,
          "tested_by_company": null,
          "tested_date": null,
          "tested_by_signature_image": null,            
        },
        rejected: {
          rejected_remarks: '',
        },
        verified: {
          "verified_by_name": null,
          "verified_by_company": null,
          "verified_date": null,
          "verified_by_signature": null,
        },
        accepted: {
          "accepted_by_name": null,
          "accepted_by_company": null,
          "accepted_date": null,
          "accepted_by_signature": null,  
        },
      }
    }
  },
  methods: {
    populate_acceptance() {
      this.devMsg(this.oDev.debug, 'populate_comment', 'gs')
      this.devMsg(this.oDev.debug, 'this.acceptanceData')
      this.devMsg(this.oDev.debug, this.acceptanceData)

      this.oModel = this.acceptanceData;

      this.devMsg(this.oDev.debug, '', 'ge')
    },
    save_acceptance( whoseAction = '' ) {
      this.devMsg(this.oDev.debug, 'save_acceptance', 'gs')

      this.devMsg(this.oDev.debug, 'whoseAction: ' + whoseAction)

      let bProceed = true;
      let dbModel = null;
      let api_url = '';
      if ( whoseAction == 'tested' ) {
        this.oModel.tested.tested_by_name = this.oUser.name;
        this.oModel.tested.tested_by_company = this.oUser.contractor_name;;
        this.oModel.tested.tested_date = this.scGetCurrentDate();

        this.oModel.status = 'PENDING';

        api_url = apiDomain + 'qaqc/update_qaqc_tested_by/' + this.$route.params.id;
        dbModel = this.oModel.tested;
      } else if ( whoseAction == 'verified' ) {
        this.oModel.verified.verified_by_name = this.oUser.name;
        this.oModel.verified.verified_by_company = this.oUser.contractor_name;;
        this.oModel.verified.verified_date = this.scGetCurrentDate();

        this.oModel.status = 'VERIFIED';

        api_url = apiDomain + 'qaqc/verified_qaqc/' + this.$route.params.id;
        dbModel = this.oModel.verified;
      } else if ( whoseAction == 'accepted' ) {
        this.oModel.accepted.accepted_by_name = this.oUser.name;
        this.oModel.accepted.accepted_by_company = this.oUser.contractor_name;;
        this.oModel.accepted.accepted_date = this.scGetCurrentDate();

        this.oModel.status = 'APPROVED';

        api_url = apiDomain + 'qaqc/approve_qaqc/' + this.$route.params.id;
        dbModel = this.oModel.accepted;
      } else if ( whoseAction == 'rejected' ) {
        this.oModel.status = 'REJECTED';

        api_url = apiDomain + 'qaqc/reject_qaqc/' + this.$route.params.id;
        dbModel = this.oModel.rejected;
      } else {
        bProceed = false;
      }
      
      if ( bProceed ) {
        this.$refs['modal-loading-in-progress'].show();

        this.devMsg(this.oDev.debug, 'API hit: ' + api_url);
        this.devMsg(this.oDev.debug, 'PAYLOAD: dbModel');
        this.devMsg(this.oDev.debug, dbModel);

        axios
        .post(api_url, dbModel, { headers: getHeader() })
        .then((response) => {
          if (response.status === 200) {
            this.msg_notify_ok('<b>PV Successfully submit acceptence data.</b>');
          }
        })
        .catch((error) => {
          if (error.response) {
            // Handle error with response
            this.errorFunction(error, "Submit acceptance");
          } else {
            // Handle error without response
            this.msg_notify_sembcorp();
          }
        })
        .finally(() => {
          this.$refs['modal-loading-in-progress'].hide();
        });

      } else {
        this.redErrorNotify("<b>Invalid Action : Action not accepted.</b>");
      }

      this.devMsg(this.oDev.debug, '', 'ge')
    },
    get_user_detail_info() {
      const userInfo = JSON.parse(window.localStorage.getItem("loginUser"));
      this.devMsg(this.oDev.debug, 'userInfo')
      this.devMsg(this.oDev.debug, userInfo)

      axios
      .get(apiDomain + 'setup/user/' + userInfo.id,  { headers: getHeader() })
      // .get(apiDomain + 'setup/user/405',  { headers: getHeader() })
      .then ( response => {          
        if (response.status === 200) {
          this.devMsg(this.oDev.debug, 'get_user_detail_info', 'gs')

          this.devMsg(this.oDev.debug, 'API setup/user/')
          this.devMsg(this.oDev.debug, response)

          this.oUser.id = response.data.data[0].id;
          this.oUser.name = response.data.data[0].name;
          this.oUser.role_id = response.data.data[0].role.role_id;
          this.oUser.role_name = response.data.data[0].role.role_name;
          if ( this.oUser.role_id == 12 ) {
            this.oUser.contractor_id = response.data.data[0].contractor.contractor_id;
            this.oUser.contractor_code = response.data.data[0].contractor.contractor_code;
            this.oUser.contractor_name = response.data.data[0].contractor.contractor_name;
          } else {
            this.oUser.contractor_id = response.data.data[0].developers[0].developer.developer_id;
            this.oUser.contractor_code = response.data.data[0].developers[0].developer.developer_code;
            this.oUser.contractor_name = response.data.data[0].developers[0].developer.developer_name;
          }

          this.devMsg(this.oDev.debug, 'this.oUser')
          this.devMsg(this.oDev.debug, this.oUser)

          this.devMsg(this.oDev.debug, '', 'ge')
        }
      })
      .catch ( error => {
        console.log(error.response.data.errors)
        this.errorFunction(error, "Create New User")
      });     
    },
    action_reject( whatAction = 'show_modal' ) {
      this.devMsg(this.oDev.debug, 'action_reject', 'gs')

      this.devMsg(this.oDev.debug, 'whoseAction: ' + whatAction)

      let dbModel = null;
      let api_url = '';
      if ( whatAction == 'execute' ) {
        this.$refs['modal-loading-in-progress'].show();

        this.oModel.status = 'REJECTED';

        api_url = apiDomain + 'qaqc/reject_qaqc/' + this.$route.params.id;
        dbModel = this.oModel.rejected;

        this.devMsg(this.oDev.debug, 'API hit: ' + api_url);
        this.devMsg(this.oDev.debug, 'PAYLOAD: dbModel');
        this.devMsg(this.oDev.debug, dbModel);

        axios
        .post(api_url, dbModel, { headers: getHeader() })
        .then((response) => {
          if (response.status === 200) {
            this.msg_notify_ok('<b>PV Successfully submit reject data.</b>');
          }
        })
        .catch((error) => {
          if (error.response) {
            // Handle error with response
            this.errorFunction(error, "Submit Reject");
          } else {
            // Handle error without response
            this.msg_notify_sembcorp();
          }
        })
        .finally(() => {
          this.$refs['modal-loading-in-progress'].hide();
          this.$refs['modal-reject-acceptance'].hide();
        });
      } else if ( whatAction == 'hide_modal' ) {
        this.$refs['modal-reject-acceptance'].hide();
      } else {
        this.$refs['modal-reject-acceptance'].show();
      }
      this.devMsg(this.oDev.debug, '', 'ge')
    },

    save_comment() {
      if (this.validate_comment()) {
        this.$refs['modal-loading-in-progress'].show();

        this.devMsg(this.oDev.debug, 'save_comment', 'gs');

        // let api_url = apiDomain + 'qaqc/create_qaqc_comments/' + this.$route.params.id;
        let api_url = apiDomain + 'qaqc/update_qaqc_comments/' + this.$route.params.id;

        this.devMsg(this.oDev.debug, 'api_url')
        this.devMsg(this.oDev.debug, api_url)

        this.devMsg(this.oDev.debug, 'PAYLOAD this.oModel')
        this.devMsg(this.oDev.debug, this.oModel)

        axios
          .post(api_url, this.oModel, { headers: getHeader() })
          .then((response) => {
            if (response.status === 200) {
              this.msg_notify_ok('<b>Update Comment Successfully Created and Submitted.</b>');
            }
          })
          .catch((error) => {
            if (error.response) {
              // Handle error with response
              this.errorFunction(error, "Update Comment Entry Submit");
            } else {
              // Handle error without response
              this.msg_notify_sembcorp();
            }
          })
          .finally(() => {
            this.$refs['modal-loading-in-progress'].hide();
          });

        this.devMsg(this.oDev.debug, '', 'ge');
      }
    },
    validate_comment() {
      let checker = false;
      if (
        !this.oModel.comments
      ) {
        if (!this.oModel.comments) {
          this.redErrorNotify("<b>Invalid Input : Comment is a Mandatory Field.</b>");
        } else {
          this.redErrorNotify("<b>Invalid Input : Please fill in all the Mandatory Fields.</b>");
        }
      } else {
        checker = true;
      }

      let arrFE = this.oModel.fire_extinguisher;
      if( arrFE.length > 0 ) {
        arrFE.forEach( (entry => {
          if (
            !entry.location ||
            !entry.number_of_extinguisher ||
            !entry.fire_extinguisher_expired_date
          ) {
            checker = false
          }
        }))

        if ( !checker ) {
          this.redErrorNotify("<b>Invalid Input : All field in Fire Extinguisher is a Mandatory Field.</b>");
        }

      }

      return checker;
    },
    fire_extinguisher_add() {
      this.devMsg(this.oDev.debug, 'fire_extinguisher_add', 'gs')

      this.oModel.fire_extinguisher.push({
        location: '',
        number_of_extinguisher: '',
        fire_extinguisher_expired_date: '',
      });

      this.devMsg(this.oDev.debug, 'this.oModel')
      this.devMsg(this.oDev.debug, this.oModel)

      this.devMsg(this.oDev.debug, '', 'ge')
    },
    fire_extinguisher_remove(index) {
      this.oModel.fire_extinguisher.splice(index, 1);
    },

  },
  computed: {
    //status: DRAFT | PENDING | REJECTED | VERIFIED | APPROVED
    approval_tested() {
      this.devMsg(this.oDev.debug, 'approval_tested status: ' + this.oModel.status)
      return (this.shareData.is_epc) && (this.oModel.status == 'DRAFT' || this.oModel.status == 'REJECTED');
      // return this.oModel.status !== 'PENDING' || this.oModel.status !== 'VERIFIED' ;
    },
    approval_rejected() {
      this.devMsg(this.oDev.debug, 'approval_rejected status: ' + this.oModel.status)
      return (!this.shareData.is_epc) && this.oModel.status === 'PENDING';
    },
    approval_verified() {
      this.devMsg(this.oDev.debug, 'approval_verified status: ' + this.oModel.status)
      return (!this.shareData.is_epc) && this.oModel.status === 'PENDING';
    },
    approval_accepted() {
      this.devMsg(this.oDev.debug, 'approval_accepted status: ' + this.oModel.status)
      return (!this.shareData.is_epc) && this.oModel.status == 'VERIFIED';
    },
  },
  created() {
    this.devMsg(this.oDev.debug, 'created', 'gs')
    this.devMsg(this.oDev.debug, this.acceptanceData, 'ge');

    this.get_user_detail_info();
    this.populate_acceptance();
  },
  mounted() {
  },
  beforeMount() {
  }
}
</script>

<!-- form element -->
<style scoped>
/deep/ hr {
  background-color: white;
}

/deep/ .form-control {
  background-color: #fff;
  border-color: #fff;
  color: #000;

  &:focus {
    background-color: #fff;
    border-color: #fff;
    /* color: white; */
  }

  &::placeholder {
    color: rgb(163, 163, 163);
  }
}

/deep/ .form-control {
  &:focus {
    &::placeholder {
      color: rgb(163, 163, 163);
    }
  }
}

/deep/ .input-group-text {
  background-color: #2C545A;
  ;
  color: white;

  &:focus {
    background-color: #2C545A;
    ;
    border-color: #1D4147;
    color: white;
  }
}

/deep/ input::-webkit-input-placeholder {
  color: #fff;
}

/deep/ input::-moz-input-placeholder {
  color: #fff;
}

/deep/ input::-ms-input-placeholder {
  color: #fff;
}

/deep/ .el-input .el-input__inner {
  background-color: #2C545A;
  color: #fff;
  border: 0px;
  border-radius: 10px;
  padding-top: 3px;
  padding-bottom: 2px;

  /* &::placeholder {
    color: white;
  } */
}

/deep/ .el-select-dropdown__item.hover,
.el-select-dropdown__item:hover {
  background-color: #23504e;
}

/deep/ .el-select-dropdown {
  background-color: #306b74;
  margin: 0px;
}

/deep/ .el-select-dropdown__item {
  color: white;
  background-color: #183034;

  ::hover {
    background-color: #2C545A
  }

}

/deep/ .el-select {
  .el-input .el-input__inner {
    &::placeholder {
      color: white;
    }
  }

}

/deep/ .el-select__input {
  color: white;
  background-color: #2C545A;
}

/deep/ .el-select__input.hover,
.el-select__input:hover {
  background-color: #23504e;
}
</style>

<!-- tabs -->
<style scoped>
/deep/ .tabs {
  background-color: #24454a;
}

/*  .nav-tabs .nav-item.show .nav-link, .nav-tabs  */

/deep/ .nav-link.active {
  color: #ffffff !important;
  background-color: #2c585f !important;
  border-color: #ffffff #ffffff #24454a !important;
}

/deep/ .tab-content {
  padding: 10px;
}

/deep/ .card {
  background-color: #2c585f;
}

/deep/ .card-footer {
  /* padding: 0.5rem 0.5rem; */
  padding-bottom: 15px;
  background-color: #24454a;
  border-top: 1px solid rgba(0, 0, 0, .05);
}
</style>

<!-- modal -->
<style scoped>
/deep/ .modal-content {
  background-color: #306b74 !important;
}

/deep/ .modal-body {
  background-color: #306b74 !important;
}

/deep/ .modal-row-header {
  padding-bottom: 20px;
}

/deep/ .modal-row-category {
  padding-top: 25px;
  padding-bottom: 0px;
}
</style>

<!-- dropdown action menu -->
<style scoped>
/deep/ .btn-dark,
.btn-dark:hover {
  color: #fff;
  background-color: #2c545a;
  border-color: #2c545a;
}

/deep/ .dropdown-menu {
  background-color: #23444a !important;
  border: 1px solid #ffffff;
}

/deep/ .dropdown-item {
  &:hover {
    background-color: #3a656b !important;
    color: #ffffff;
  }

  span {
    padding-left: 8px;
    vertical-align: super;
  }
}
</style>